// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"580dc4a6","110":"cfc33c8d","368":"ff9256db","406":"3eff0196","453":"452420c8","577":"fc14106c","723":"25a3e855","744":"3e878295"}[chunkId] + ".chunk.js";
};